import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Card, CardImage } from '@blueprint/ui';
import { FeatureList } from '@zoopla/listings/features';

export const StyledListingCardPortrait = styled(Card)(
    ({ theme: { focusRing, borderRadius } }) => css`
        display: flex;
        flex-direction: column;
        border-radius: ${borderRadius['400']};
        padding: 0;
        height: 100%;
        width: 17.5rem;
        text-decoration: none;

        :focus {
            box-shadow: ${focusRing};
            outline: 0;
        }

        ${CardImage} {
            margin: 0;
            min-width: 100%;
            height: 100%;
            object-fit: cover;
        }
    `
);

export const StyledListingCardPortraitLink =
    StyledListingCardPortrait.withComponent('a');

export const StyledListingCardPortraitTitle = styled('p')(
    ({ theme: { type, colors, fontWeight } }) => css`
        margin: 0;
        line-height: ${type.lineHeight};
        color: ${colors['text-body']};
        font-size: ${type.secondary};
        color: ${colors['text-placeholder']};
        font-weight: ${fontWeight.bold};
    `
);

export const StyledListingCardPortraitPrice = styled('p')(
    ({ theme: { type, colors, fontWeight } }) => css`
        margin: 0;
        line-height: ${type.lineHeight};
        font-size: ${type[7]};
        color: ${colors['text-body']};
        font-weight: ${fontWeight.bold};
    `
);

export const StyledListingCardPortraitAddress = styled('p')(
    ({ theme: { type, colors } }) => css`
        margin: 0;
        line-height: ${type.lineHeight};
        color: ${colors['text-body']};
        font-size: ${type[8]};
    `
);

export const StyledListingCardPortraitDetails = styled('div')(
    ({ theme: { spacing } }) => css`
        display: flex;
        flex: 1;
        min-height: 15rem;
        flex-direction: column;
        align-items: flex-start;
        padding: ${spacing['16px']};
        max-width: 100%;

        ${StyledListingCardPortraitPrice} {
            margin-top: ${spacing['8px']};
            max-width: 100%;
        }
        ${StyledListingCardPortraitAddress} {
            margin-top: ${spacing['8px']};
            white-space: normal;
            max-width: 100%;
        }
        ${FeatureList} {
            margin-top: auto;
            padding-top: ${spacing['16px']};
        }
    `
);
